export default "__VITE_ASSET__CmP4yYlH__"